/// <reference path="../../Common/Helpers/GridEditorBase.ts" />
namespace GeniuzPOS.Member {

    @Serenity.Decorators.registerClass()
    export class MbReport_01_Dt_Editor extends Serenity.Extensions.GridEditorBase<MbReport_01_Dt_Row> {
        protected getColumnsKey() { return "Member.MbReport_01_Dt_"; }
        protected getDialogType() { return MbReport_01_Dt_Dialog; }
        protected getLocalTextPrefix() { return MbReport_01_Dt_Row.localTextPrefix; }

        public qnNo: number;

        public myPassValue: string;        
        

        constructor(container: JQuery) {
            super(container);
        
        }      

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
           
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
                       
            return buttons;
        }
    
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            opt.showFooterRow = true;
            return opt;
        }

        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.localSort = true;
            return opt;
        }

        protected usePager() {
            return false;
        }

    }
}

